import React, { Component } from 'react';
import classnames from 'classnames';
import { Spin, Modal, Row, Col, Affix, Button, BackTop, Icon } from 'antd';
import { ArticleModal } from 'modules/modal';
import socket from 'helpers/esocket';
import { signout } from 'modules/me/actions';
import { DropTarget, DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import PcLayout from './PcLayout';
import _ from 'lodash';
import moment from 'moment';

import clientId from 'clientId';
import {actions as sourceGroup} from 'modules/sourceGroup';

import { init } from '../actions';

import './style.css';
class Base extends Component {

  state = {
    showAffix: false
  }

  componentDidMount() {
    const { dispatch, userId, accessToken, subject } = this.props;
    if (localStorage.downTime !== moment().format('YYYY-MM-DD')) {
      delete localStorage.downLimit
    }
    socket.on(`${clientId}-Login-${userId}`, (data) => {
      if (data == 'logout') {
        socket.emit('clientID', `${clientId}-Login-${userId}`, null)
        //跳轉出登錄頁
        Modal.warning({
          title: t('loginConflictTitle'),
          okText: t('commonConfirm'),
          content: (
            <div>
              <p>{t('loginConflictContent')}</p>
            </div>
          ),
          onOk() {
            dispatch(signout())
          },
        });
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(_.get(this.props, 'subject.navBarSubjectLabel.data[0]'),_.get(nextProps, 'subject.navBarSubjectLabel.data[0]'))){
      const {subject, dispatch} = nextProps;
      const subjects = _.get(subject, 'entities');
      const subjectId = _.get(subject, 'navBarSubjectLabel.data[0]')
      const sourceGroupLabel = _.get(subjects, `[${subjectId}].sourceGroupLabel`)
      dispatch(sourceGroup.fetchSourceGroup({label: sourceGroupLabel}))
    }
  }

  render() {
    const {
      header,
      sidebar,
      body,
      isCollapsed,
      isInited,
      isShowClippingPanel,
      router
    } = this.props;
    const routers = router.split('/')
    const pathname = routers[1];
    return (
      <div>
        {!isInited &&
          <div className="loading">
            Loading...
          </div>
        ||
        <div>
          <PcLayout sidebar={sidebar} body={body} pathname={pathname}/>
          {pathname !== 'home' &&
            <BackTop  className="back-top">
              <div className="return-top">
                <Icon type="circle-o-up" />
              </div>
            </BackTop>
          }
        </div>
        }
        <ArticleModal />
      </div>
    );
  }
}
export default DragDropContext(HTML5Backend)(Base);



/** WEBPACK FOOTER **
 ** ./src/app/modules/base/components/Component.js
 **/